import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import Vue from 'vue'

const getDefaultStateForProductUoms= () => {
    return {
        uoms: [],
        is_deleted:null,
        is_created:null
    }
}

// state
const state = getDefaultStateForProductUoms()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_PRODUCT_UOMS (state) {
        Object.assign(state, getDefaultStateForProductUoms())
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_PRODUCT_UOMS")
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['PRODUCT_UOM_CREATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product UOM has been created",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                
                  commit("SET_IS_CREATED", 1)

            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }

                commit("SET_IS_CREATED", 0)
            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating UOM")
              }

              commit("SET_IS_CREATED", 0)
          });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['PRODUCT_UOM_DELETE'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  let id  = response.data.data
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product UOM has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                 commit("SET_IS_DELETED", 1)
  
              }
              else
              {
                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
                  commit("SET_IS_DELETED", 0)

              }
  
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
  
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    alert("Problem Creating UOM")
                }
            });
      }
}

export {
    state,
    getters,
    actions,
    mutations
}
